import { EditIcon } from "@components/icon";
import { WriteLineWrapper } from "@components/navigation/NavDashboard.styles";
import { ICompanyEntity } from "@odata/GeneratedEntityTypes";
import { GeneralPermissionCode } from "@odata/GeneratedEnums";
import { ICompanyFormCustomData } from "@pages/companies/Company.types";
import { getCompanyLogoUrl } from "@utils/CompanyUtils";
import React, { useCallback, useContext } from "react";

import { PermissionContext } from "../../contexts/permissionContext/PermissionContext";
import { AvatarSize } from "../../enums";
import { FormStorage } from "../../views/formView/FormStorage";
import { AvatarStyledCompany } from "./Company.styles";
import { CompanyFormAvatarButton } from "./CompanyDashboard.styles";

interface IProps {
    storage: FormStorage<ICompanyEntity, ICompanyFormCustomData>;
    fieldElement: React.ReactNode;
}

const CompanyFormAvatarWithName: React.FC<IProps> = (props) => {
    const { storage, fieldElement } = props;

    const permissionContext = useContext(PermissionContext);

    const company = storage.data.entity;
    const logoUrl = getCompanyLogoUrl(company);

    const isDisabled = !permissionContext.generalPermissions.has(GeneralPermissionCode.CompanyManagement);
    const handleAvatarEdit = useCallback(() => {
        storage.setCustomData({ isAvatarSelectionOpen: true });
        storage.refresh();
    }, [storage]);

    return (<>
        <AvatarStyledCompany src={logoUrl} size={AvatarSize.XL}>
            <CompanyFormAvatarButton isDisabled={isDisabled}
                                     onClick={handleAvatarEdit}
                                     title={storage.t("Common:General.Edit")}>
                <EditIcon isLight/>
            </CompanyFormAvatarButton>
        </AvatarStyledCompany>
        <WriteLineWrapper isBig>
            {fieldElement}
        </WriteLineWrapper>
    </>);
};

export default CompanyFormAvatarWithName;